import script from "./FullPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./FullPopup.vue?vue&type=script&setup=true&lang=ts"

import "./FullPopup.vue?vue&type=style&index=0&id=522c505e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-522c505e"]])

export default __exports__